import type { AdvertiserPermissions, PermissionsResponse, SlugifiedPermissions } from '../../lib/api/permission/dto';

export const checkAdvertisersFactory =
  (advertiserPermissions: AdvertiserPermissions | undefined) => (permission: keyof AdvertiserPermissions) =>
    Boolean(advertiserPermissions?.[permission]);

export const checkSignalsFactory =
  (slugifiedPermissions: SlugifiedPermissions | undefined) =>
  (permission: string): boolean =>
    slugifiedPermissions?.signalPermissions?.[permission] ?? false;

export const checkLifeScopeFactory =
  (slugifiedPermissions: SlugifiedPermissions | undefined) =>
  (permission: string): boolean =>
    slugifiedPermissions?.lifePermissions?.[permission] ?? false;

export const checkStudioFactory =
  (slugifiedPermissions: SlugifiedPermissions | undefined) =>
  (permission: string): boolean =>
    slugifiedPermissions?.genomeStudioPermissions?.[permission] ?? false;

export const checkTopLevelPermission = (
  permissionsData: PermissionsResponse | undefined,
  permission: keyof PermissionsResponse,
): boolean => (typeof permissionsData?.[permission] === 'boolean' ? permissionsData[permission] : false);

// Helper to convert a string to camelCase
const slugify = (str: string): string => {
  return String(str)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .toLowerCase()
    .replace(/(?:^|\s|\b)(\w)/g, (_, p1, offset) => (offset === 0 ? p1.toLowerCase() : p1.toUpperCase()))
    .replace(/\s+/g, '');
};

export const getSlugifiedPermissions = (permissions: { id: number; name: string }[]): Record<string, boolean> => {
  return permissions.reduce(
    (acc, curr) => {
      acc[slugify(curr.name)] = true;
      return acc;
    },
    {} as Record<string, boolean>,
  );
};
